<template>
  <section v-if="shareLinkId && shareContent && adzRefList && clientInfos">
    <img class="top-insta-logo" src="@/assets/img/platform/instagram.png" alt="Instagram logo" />

    <div class="switch-button" :class="{ instagram: facebookInstagram }" @click="switchPlatform" v-if="!previewStories">
      <p>Switch to</p>
      <img v-if="facebookInstagram" src="@/assets/img/instagram/logo-instagram.svg" alt="Instagram logo" />
      <img v-else src="@/assets/img/instagram/logo-facebook.svg" alt="Facebook logo" />
    </div>

    <header class="header-facebook" v-if="facebookInstagram === 'facebook'">
      <div class="left-head">
        <svg viewBox="0 0 36 36" fill="url(#jsc_c_2)" height="40" width="40">
          <defs>
            <linearGradient id="jsc_c_2" x1="50%" x2="50%" y1="97.0782153%" y2="0%">
              <stop offset="0%" stop-color="#0062E0"></stop>
              <stop offset="100%" stop-color="#19AFFF"></stop>
            </linearGradient>
          </defs>
          <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z"></path>
          <path
            fill="#fff"
            d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"
          ></path>
        </svg>
      </div>
      <div class="center-head">
        <div class="icon">
          <svg viewBox="0 0 28 28" class="a8c37x1j ms05siws hwsy1cff b7h9ocf4 aaxa7vy3" height="28" width="28">
            <path
              d="M25.825 12.29C25.824 12.289 25.823 12.288 25.821 12.286L15.027 2.937C14.752 2.675 14.392 2.527 13.989 2.521 13.608 2.527 13.248 2.675 13.001 2.912L2.175 12.29C1.756 12.658 1.629 13.245 1.868 13.759 2.079 14.215 2.567 14.479 3.069 14.479L5 14.479 5 23.729C5 24.695 5.784 25.479 6.75 25.479L11 25.479C11.552 25.479 12 25.031 12 24.479L12 18.309C12 18.126 12.148 17.979 12.33 17.979L15.67 17.979C15.852 17.979 16 18.126 16 18.309L16 24.479C16 25.031 16.448 25.479 17 25.479L21.25 25.479C22.217 25.479 23 24.695 23 23.729L23 14.479 24.931 14.479C25.433 14.479 25.921 14.215 26.132 13.759 26.371 13.245 26.244 12.658 25.825 12.29"
            ></path>
          </svg>
        </div>
        <div class="icon">
          <svg viewBox="0 0 28 28" class="a8c37x1j ms05siws hwsy1cff b7h9ocf4 em6zcovv" height="28" width="28">
            <path
              d="M8.75 25.25C8.336 25.25 8 24.914 8 24.5 8 24.086 8.336 23.75 8.75 23.75L19.25 23.75C19.664 23.75 20 24.086 20 24.5 20 24.914 19.664 25.25 19.25 25.25L8.75 25.25ZM17.163 12.846 12.055 15.923C11.591 16.202 11 15.869 11 15.327L11 9.172C11 8.631 11.591 8.297 12.055 8.576L17.163 11.654C17.612 11.924 17.612 12.575 17.163 12.846ZM21.75 20.25C22.992 20.25 24 19.242 24 18L24 6.5C24 5.258 22.992 4.25 21.75 4.25L6.25 4.25C5.008 4.25 4 5.258 4 6.5L4 18C4 19.242 5.008 20.25 6.25 20.25L21.75 20.25ZM21.75 21.75 6.25 21.75C4.179 21.75 2.5 20.071 2.5 18L2.5 6.5C2.5 4.429 4.179 2.75 6.25 2.75L21.75 2.75C23.821 2.75 25.5 4.429 25.5 6.5L25.5 18C25.5 20.071 23.821 21.75 21.75 21.75Z"
            ></path>
          </svg>
        </div>
        <div class="icon">
          <svg viewBox="0 0 28 28" class="a8c37x1j ms05siws hwsy1cff b7h9ocf4 em6zcovv" height="28" width="28">
            <path
              d="M17.5 23.75 21.75 23.75C22.164 23.75 22.5 23.414 22.5 23L22.5 14 22.531 14C22.364 13.917 22.206 13.815 22.061 13.694L21.66 13.359C21.567 13.283 21.433 13.283 21.34 13.36L21.176 13.497C20.591 13.983 19.855 14.25 19.095 14.25L18.869 14.25C18.114 14.25 17.382 13.987 16.8 13.506L16.616 13.354C16.523 13.278 16.39 13.278 16.298 13.354L16.113 13.507C15.53 13.987 14.798 14.25 14.044 14.25L13.907 14.25C13.162 14.25 12.439 13.994 11.861 13.525L11.645 13.35C11.552 13.275 11.419 13.276 11.328 13.352L11.155 13.497C10.57 13.984 9.834 14.25 9.074 14.25L8.896 14.25C8.143 14.25 7.414 13.989 6.832 13.511L6.638 13.351C6.545 13.275 6.413 13.275 6.32 13.351L5.849 13.739C5.726 13.84 5.592 13.928 5.452 14L5.5 14 5.5 23C5.5 23.414 5.836 23.75 6.25 23.75L10.5 23.75 10.5 17.5C10.5 16.81 11.06 16.25 11.75 16.25L16.25 16.25C16.94 16.25 17.5 16.81 17.5 17.5L17.5 23.75ZM3.673 8.75 24.327 8.75C24.3 8.66 24.271 8.571 24.238 8.483L23.087 5.355C22.823 4.688 22.178 4.25 21.461 4.25L6.54 4.25C5.822 4.25 5.177 4.688 4.919 5.338L3.762 8.483C3.729 8.571 3.7 8.66 3.673 8.75ZM24.5 10.25 3.5 10.25 3.5 12C3.5 12.414 3.836 12.75 4.25 12.75L4.421 12.75C4.595 12.75 4.763 12.69 4.897 12.58L5.368 12.193C6.013 11.662 6.945 11.662 7.59 12.193L7.784 12.352C8.097 12.609 8.49 12.75 8.896 12.75L9.074 12.75C9.483 12.75 9.88 12.607 10.194 12.345L10.368 12.2C11.01 11.665 11.941 11.659 12.589 12.185L12.805 12.359C13.117 12.612 13.506 12.75 13.907 12.75L14.044 12.75C14.45 12.75 14.844 12.608 15.158 12.35L15.343 12.197C15.989 11.663 16.924 11.663 17.571 12.197L17.755 12.35C18.068 12.608 18.462 12.75 18.869 12.75L19.095 12.75C19.504 12.75 19.901 12.606 20.216 12.344L20.38 12.208C21.028 11.666 21.972 11.666 22.62 12.207L23.022 12.542C23.183 12.676 23.387 12.75 23.598 12.75 24.097 12.75 24.5 12.347 24.5 11.85L24.5 10.25ZM24 14.217 24 23C24 24.243 22.993 25.25 21.75 25.25L6.25 25.25C5.007 25.25 4 24.243 4 23L4 14.236C2.875 14.112 2 13.158 2 12L2 9.951C2 9.272 2.12 8.6 2.354 7.964L3.518 4.802C4.01 3.563 5.207 2.75 6.54 2.75L21.461 2.75C22.793 2.75 23.99 3.563 24.488 4.819L25.646 7.964C25.88 8.6 26 9.272 26 9.951L26 11.85C26 13.039 25.135 14.026 24 14.217ZM16 23.75 16 17.75 12 17.75 12 23.75 16 23.75Z"
            ></path>
          </svg>
        </div>
        <div class="icon">
          <svg viewBox="0 0 28 28" class="a8c37x1j ms05siws hwsy1cff b7h9ocf4 em6zcovv" height="28" width="28">
            <path
              d="M25.5 14C25.5 7.649 20.351 2.5 14 2.5 7.649 2.5 2.5 7.649 2.5 14 2.5 20.351 7.649 25.5 14 25.5 20.351 25.5 25.5 20.351 25.5 14ZM27 14C27 21.18 21.18 27 14 27 6.82 27 1 21.18 1 14 1 6.82 6.82 1 14 1 21.18 1 27 6.82 27 14ZM7.479 14 7.631 14C7.933 14 8.102 14.338 7.934 14.591 7.334 15.491 6.983 16.568 6.983 17.724L6.983 18.221C6.983 18.342 6.99 18.461 7.004 18.578 7.03 18.802 6.862 19 6.637 19L6.123 19C5.228 19 4.5 18.25 4.5 17.327 4.5 15.492 5.727 14 7.479 14ZM20.521 14C22.274 14 23.5 15.492 23.5 17.327 23.5 18.25 22.772 19 21.878 19L21.364 19C21.139 19 20.97 18.802 20.997 18.578 21.01 18.461 21.017 18.342 21.017 18.221L21.017 17.724C21.017 16.568 20.667 15.491 20.067 14.591 19.899 14.338 20.067 14 20.369 14L20.521 14ZM8.25 13C7.147 13 6.25 11.991 6.25 10.75 6.25 9.384 7.035 8.5 8.25 8.5 9.465 8.5 10.25 9.384 10.25 10.75 10.25 11.991 9.353 13 8.25 13ZM19.75 13C18.647 13 17.75 11.991 17.75 10.75 17.75 9.384 18.535 8.5 19.75 8.5 20.965 8.5 21.75 9.384 21.75 10.75 21.75 11.991 20.853 13 19.75 13ZM15.172 13.5C17.558 13.5 19.5 15.395 19.5 17.724L19.5 18.221C19.5 19.202 18.683 20 17.677 20L10.323 20C9.317 20 8.5 19.202 8.5 18.221L8.5 17.724C8.5 15.395 10.441 13.5 12.828 13.5L15.172 13.5ZM16.75 9C16.75 10.655 15.517 12 14 12 12.484 12 11.25 10.655 11.25 9 11.25 7.15 12.304 6 14 6 15.697 6 16.75 7.15 16.75 9Z"
            ></path>
          </svg>
        </div>
        <div class="icon">
          <svg viewBox="0 0 28 28" class="a8c37x1j ms05siws hwsy1cff b7h9ocf4 em6zcovv" height="28" width="28">
            <path
              d="M23.5 9.5H10.25a.75.75 0 00-.75.75v7c0 .414.336.75.75.75H17v5.5H4.5v-19h19v5zm0 14h-5v-6.25a.75.75 0 00-.75-.75H11V11h12.5v12.5zm1.5.25V4.25C25 3.561 24.439 3 23.75 3H4.25C3.561 3 3 3.561 3 4.25v19.5c0 .689.561 1.25 1.25 1.25h19.5c.689 0 1.25-.561 1.25-1.25z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="right-head">
        <div class="account">
          <img src="@/assets/img/pastille.svg" alt="Showadz" />
          <p>Showadz</p>
        </div>
        <img src="@/assets/img/facebook/header-right-options.jpg" class="right-options" alt="Showadz" />
      </div>
      <img src="@/assets/img/facebook/new-mobile-header-facebook.jpg" class="mobile-header" alt="Showadz" />
    </header>

    <section class="facebook-wrap feed-facebook" v-if="facebookInstagram === 'facebook'">
      <div class="left-side-facebook">
        <div class="list-item">
          <img src="@/assets/img/pastille.svg" alt="Showadz" />
          <p>Showadz</p>
        </div>
        <div class="list-item">
          <img src="@/assets/img/facebook/pages.png" alt="Pages" />
          <p>Pages</p>
        </div>
        <div class="list-item">
          <img src="@/assets/img/facebook/friends.png" alt="Friends" />
          <p>Friends</p>
        </div>
        <div class="list-item">
          <img src="@/assets/img/facebook/messenger.png" alt="Messenger" />
          <p>Messenger</p>
        </div>
        <div class="list-item">
          <img src="@/assets/img/facebook/events.png" alt="Events" />
          <p>Events</p>
        </div>
        <div class="list-item">
          <img src="@/assets/img/facebook/marketplace.png" alt="Marketplace" />
          <p>Marketplace</p>
        </div>
        <div class="line"></div>
        <p class="sub-title">Your Shortcuts</p>
        <a href="https://jnv.dev/" target="_blank" class="list-item page">
          <img src="@/assets/img/facebook/jnv.jpg" alt="J&V" />
          <p>J&V</p>
        </a>
        <div class="list-item page">
          <img src="@/assets/img/facebook/starbucks.png" alt="Starbucks" />
          <p>Starbucks</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/youtube.jpg" alt="Youtube" />
          <p>Youtube</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/chrome.png" alt="Chrome" />
          <p>Chrome</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/invision.png" alt="InVision" />
          <p>InVision</p>
        </div>
      </div>

      <div class="center-facebook">
        <div class="stories-wrap" v-if="shareContent.adz && allSharedStoriesAdz && allSharedStoriesAdz.length">
          <a href="#" v-for="(adzItem, i) in allSharedStoriesAdz" :key="'st-a-' + i" class="story" @click.prevent="openStoriesPreview(adzItem)">
            <adz-image :adz="adzItem" :app-domain="appDomain" :shared-account="[{id: shareContent.accountId}]"></adz-image>
          </a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
        </div>
        <div class="stories-wrap" v-else-if="!shareContent.adz && allStoriesAdz && allStoriesAdz.length">
          <a v-for="(adzItem, i) in allStoriesAdz" :key="'st-a-' + i" href="'#'" class="story" @click.prevent="openStoriesPreview(adzItem)">
            <adz-image
              :adz="adzItem"
              :app-domain="appDomain"
              :shared-account="[{id: shareContent.accountId}]"
            ></adz-image>
          </a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
          <a href="#" class="story is-ph"></a>
        </div>

        <div class="center-wrap-style">
          <img src="@/assets/img/facebook/new-write-post-facebook.jpg" class="write-post" alt="Facebook" />
        </div>

        <div v-if="shareContent.adz && shareContentAdz && shareContentAdz.length">
          <!-- SIMPLE PRODUIT 1:1 -->
          <SimpleProduit
            v-for="(adz, index) in shareContentAdz"
            :key="index"
            :adz="adz"
            :client="{
              name: clientInfos.name,
              profileImg: clientInfos.profileImg,
            }"
            :show-approve="true"
            :shared-account="[{id: shareContent.accountId}]"
            :account-id="shareContent.accountId"
            :client-id="shareContent.clientId"
            :campaign-id="shareContent.campaignId"
            :adz-id="adz.id"
            :is-public="true"
            :refresh-adz-view="refreshAdzView"
            :platform="facebookInstagram"
          />
        </div>
        <div v-else-if="!shareContent.adz && adzRefList && adzRefList.length">
          <!-- SIMPLE PRODUIT 1:1 -->
          <SimpleProduit
            v-for="(adz, index) in adzRefList"
            :key="index"
            :adz="adz"
            :client="{
              name: clientInfos.name,
              profileImg: clientInfos.profileImg,
            }"
            :show-approve="true"
            :shared-account="[{id: shareContent.accountId}]"
            :account-id="shareContent.accountId"
            :client-id="shareContent.clientId"
            :campaign-id="shareContent.campaignId"
            :adz-id="adz.id"
            :is-public="true"
            :refresh-adz-view="refreshAdzView"
            :platform="facebookInstagram"
          />
        </div>
      </div>

      <div class="right-side-facebook">
        <p class="sub-title">Sponsored</p>
        <a href="https://jnv.dev/" target="_blank" class="list-item pub">
          <img src="@/assets/img/facebook/julien-vincent.jpg" alt="Julien Aubrey et Vincent Bourdeau" />
          <div class="data">
            <p>We make your digital projects a personal matter!</p>
            <p class="link">jnv.dev</p>
          </div>
        </a>
        <div class="line"></div>
        <p class="sub-title">Birthdays</p>
        <div class="list-item">
          <img src="@/assets/img/facebook/birthday.png" alt="Birthdays" />
          <p><strong>Jackie Chan</strong> and <strong>Beyoncé</strong> have birthdays today.</p>
        </div>
        <div class="line"></div>
        <p class="sub-title">Contacts</p>
        <div class="list-item page">
          <img src="@/assets/img/facebook/cristiano.jpg" alt="Cristiano Ronaldo" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/shakira.jpg" alt="Shakira" />
          <p>Shakira</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/lionel.jpg" alt="Lionel Messi" />
          <p>Lionel Messi</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/will.png" alt="Will Smith" />
          <p>Will Smith</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/vin.jpg" alt="Vin Diesel" />
          <p>Vin Diesel</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/rihanna.jpg" alt="Rihanna" />
          <p>Rihanna</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/eminem.jpg" alt="Eminem" />
          <p>Eminem</p>
        </div>
        <div class="list-item page">
          <img src="@/assets/img/facebook/justin.jpg" alt="Justin Bieber" />
          <p>Justin Bieber</p>
        </div>
      </div>
    </section>

    <!-- INSTAGRAM -->

    <div class="instagram-wrap" v-if="facebookInstagram === 'instagram'">
      <div class="phone-frame">
        <div class="main-header">
          <img src="@/assets/img/instagram/main-header.jpg" alt="Instagram header" />
        </div>
        <div class="content">

          <div class="stories-wrap" v-if="allStoriesAdz && allStoriesAdz.length">
            <a href="#"
              v-for="(adzItem, i) in allStoriesAdz"
              :key="'st-a-' + i"
              @click.prevent="openStoriesPreview(adzItem)"
              class="story"
            >
              <div class="wrap"><adz-image :adz="adzItem" :app-domain="appDomain"></adz-image></div>
            </a>
            <a href="#" class="story is-ph"><div class="wrap"></div></a>
            <a href="#" class="story is-ph"><div class="wrap"></div></a>
            <a href="#" class="story is-ph"><div class="wrap"></div></a>
            <a href="#" class="story is-ph"><div class="wrap"></div></a>
            <a href="#" class="story is-ph"><div class="wrap"></div></a>
          </div>

          <div v-if="shareContent.adz">
            <!-- SIMPLE PRODUIT 1:1 -->
            <SimpleProduit
              v-for="(adz, index) in shareContent.adz"
              :key="index"
              :adz="adzRefList.find((i) => i.id === adz)"
              :client="{
                name: clientInfos.name,
                profileImg: clientInfos.profileImg,
              }"
              :show-approve="true"
              :shared-account="[{id: shareContent.accountId}]"
              :account-id="shareContent.accountId"
              :client-id="shareContent.clientId"
              :campaign-id="shareContent.campaignId"
              :adz-id="adz"
              :is-public="true"
              :refresh-adz-view="refreshAdzView"
              :platform="facebookInstagram"
            />
          </div>
          <div v-else-if="adzRefList && adzRefList.length">
            <!-- SIMPLE PRODUIT 1:1 -->
            <SimpleProduit
              v-for="(adz, index) in adzRefList"
              :key="index"
              :adz="adz"
              :client="{
                name: clientInfos.name,
                profileImg: clientInfos.profileImg,
              }"
              :show-approve="true"
              :shared-account="[{id: shareContent.accountId}]"
              :account-id="shareContent.accountId"
              :client-id="shareContent.clientId"
              :campaign-id="shareContent.campaignId"
              :adz-id="adz.id"
              :is-public="true"
              :refresh-adz-view="refreshAdzView"
              :platform="facebookInstagram"
            />
          </div>
        </div>
        <div class="main-footer">
          <img src="@/assets/img/instagram/main-footer.jpg" alt="Instagram footer" />
        </div>
      </div>
    </div>

    <!-- Stories Previewer -->
    <StoriesPreview
      v-if="previewStories && allSharedStoriesAdz"
      :previewStories="previewStories"
      :allStoriesAdz="allSharedStoriesAdz"
      :closeStoriesPreview="closeStoriesPreview"
      :client="{
        name: clientInfos.name,
        profileImg: clientInfos.profileImg,
      }"
      :show-approve="true"
      :shared-account="[{id: shareContent.accountId}]"
      :account-id="shareContent.accountId"
      :client-id="shareContent.clientId"
      :campaign-id="shareContent.campaignId"
      :hidePreviewClose="hidePreviewClose"
    />
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNil } from 'lodash'
import SimpleProduit from '@/components/facebook/SimpleProduit'
import ShareLinksDB from '@/firebase/shareLinks-db'
import AccountclientsDB from '@/firebase/account-clients-db'
import AccountClientCampaignAdzDB from '@/firebase/account-client-campaign-adz-db'
import AdzImage from '@/components/facebook/AdzImage'
import StoriesPreview from '@/components/facebook/StoriesPreview'

// import Flickity from 'vue-flickity';

export default {
  head: function () {
    return {
      title: {
        inner: 'Preview Facebook ads',
      },
      meta: [
        // Global Metas OG
        { name: 'application-name', content: 'Showadz' },
        {
          name: 'description',
          content: `Facebook ads preview for approbation`,
          id: 'desc',
        },
        // Twitter OG
        { name: 'twitter:title', content: 'Showadz' },
        { name: 'twitter:card', content: 'summary' },
        {
          n: 'twitter:description',
          c: `Facebook ads preview for approbation`,
        },
        // Facebook / Open Graph
        { property: 'og:title', content: 'Showadz' },
        { property: 'og:site_name', content: 'Showadz' },
        { property: 'og:type', content: `Website` },
        {
          property: 'og:description',
          content: `Facebook ads preview for approbation`,
        },
        // Og Image
        {
          p: 'og:image',
          c: 'https://firebasestorage.googleapis.com/v0/b/showadz-prod-6a02e.appspot.com/o/og-facebook-ads.jpg?alt=media&token=58fbc09d-dfb1-4c6a-b2b7-e1299e373406',
        },
        {
          name: 'twitter:image',
          content:
            'https://firebasestorage.googleapis.com/v0/b/showadz-prod-6a02e.appspot.com/o/og-facebook-ads.jpg?alt=media&token=58fbc09d-dfb1-4c6a-b2b7-e1299e373406',
        },
      ],
    }
  },

  components: {
    SimpleProduit,
    AdzImage,
    StoriesPreview,
    // Flickity
  },

  data() {
    return {
      shareContent: null,
      shareContentAdz: [],
      allSharedStoriesAdz: [],
      adzRefList: null,
      allStoriesAdz: [],
      clientInfos: null,
      facebookInstagram: 'facebook',
      isSaving: false,
      previewStories: null,
      hidePreviewClose: false,
      instagramOptions: {
        imagesLoaded: true,
        groupCells: false,
        pageDots: true,
        percentPosition: false,
        contain: true,
        lazyLoad: 2,
        setGallerySize: false,
      },
    }
  },

  computed: {
    shareLinkId() {
      return this.$route.query.slid
    },
    ...mapState('app', ['appTitle', 'commentsToggle', 'appDomain']),
  },

  watch: {
    $route: {
      async handler($route) {
        if (!isNil($route) && $route.name === 'share-link-dynamic') {
          // Use new route
          this.$router.push({ name: 'share-link', query: { slid: $route.params.shareLinkId } })
          return
        }
      },
      immediate: true,
    },

    shareLinkId: {
      async handler(shareLinkId) {
        if (!isNil(shareLinkId)) {
          // console.log('account', 'changed')

          const shareLinksDbRef = new ShareLinksDB()
          this.shareContent = await shareLinksDbRef.read(shareLinkId)

          const AccountclientsDBRef = new AccountclientsDB(this.shareContent.accountId)
          this.clientInfos = await AccountclientsDBRef.read(this.shareContent.clientId)

          this.refreshAdzView()
        }
      },
      immediate: true,
    },
  },

  methods: {
    async approveAdz(adz) {
      let toggleApprove = true

      if (adz.isApproved) {
        toggleApprove = false
      }

      const accountClientCampaignAdzDbRef = new AccountClientCampaignAdzDB(
        this.shareContent.accountId,
        this.shareContent.clientId,
        this.shareContent.campaignId
      )

      const approvedAdz = { ...adz, isApproved: toggleApprove }

      await accountClientCampaignAdzDbRef.update(approvedAdz)
      adz.isApproved = toggleApprove
    },

    async refreshAdzView() {
      const accountClientCampaignAdzDbRef = new AccountClientCampaignAdzDB(
        this.shareContent.accountId,
        this.shareContent.clientId,
        this.shareContent.campaignId
      )
      const adzRefList = await accountClientCampaignAdzDbRef.readAll(null, false, 'createTimestamp')
      this.adzRefList = adzRefList.filter((i) => i.isReady && i.type !== 'stories')
      this.allStoriesAdz = adzRefList.filter((i) => i.isReady && i.type === 'stories')

      // Share some
      if (this.shareContent.adz) {
        const sharedRegularAdz = []
        for (const val of Object.entries(this.shareContent.adz)) {
          const tAdz = this.adzRefList.find((i) => i.isReady && i.type !== 'stories' && i.id === val[1])
          if (tAdz) {
            sharedRegularAdz.push(tAdz)
          }
        }
        this.shareContentAdz = sharedRegularAdz

        const sharedStoriesAdz = []
        for (const val of Object.entries(this.shareContent.adz)) {
          const tAdz = this.allStoriesAdz.find((i) => i.isReady && i.type === 'stories' && i.id === val[1])
          if (tAdz) {
            sharedStoriesAdz.push(tAdz)
          }
        }
        this.allSharedStoriesAdz = sharedStoriesAdz
      } else {
        // Share All
        this.shareContentAdz = this.adzRefList
        this.allSharedStoriesAdz = this.allStoriesAdz
      }

      if (!this.shareContentAdz.length && this.allSharedStoriesAdz) {
        this.openStoriesPreview(this.allSharedStoriesAdz[0])
        this.hidePreviewClose = true
      }
    },

    switchPlatform() {
      this.facebookInstagram = this.facebookInstagram === 'facebook' ? 'instagram' : 'facebook'
    },

    openStoriesPreview(adzItem) {
      console.log(123213123213123);
      this.previewStories = adzItem
    },

    closeStoriesPreview() {
      this.previewStories = null
    },

    ...mapActions('app', ['doAlert']),
  },
}
</script>

<style lang="scss">
@import '@/theme/variables.scss';
@import '@/theme/typography.scss';
@import '@/theme/button.scss';

.top-insta-logo {
  position: fixed;
  top: 8px;
  left: 16px;
  width: auto;
  height: 40px;

  @media screen and (max-width: 570px) {
    display: none !important;
  }
}

.switch-button {
  position: fixed;
  top: 8px;
  left: 70px;
  z-index: 100000;
  width: 110px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #4facf8 0%, #2463d8 100%);
  border-radius: 5px;
  padding: 0 10px;
  cursor: pointer;

  &.instagram {
    background: linear-gradient(90deg, rgba(255, 213, 33, 1) 0%, rgba(245, 0, 0, 1) 35%, rgba(185, 0, 180, 1) 100%);
  }

  p {
    color: #fff;
    font-size: 14px;
  }

  img {
    width: auto;
    height: 25px;
  }

  @media screen and (max-width: 570px) {
    left: 16px;
    top: 0;
    margin-bottom: 10px;
    position: relative;
  }
}

.page-Facebook,
.page-facebook-preview-all,
.page-share-link {
  background-color: #e9ebee;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  color: #1d2129;

  .navbar {
    display: none;
  }

  .main-wrap {
    margin-top: 0;
  }

  .facebook-wrap {
    width: 1010px;
    max-width: 1010px;
    margin: 0 auto;
    position: relative;
    z-index: 3500;

    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }

  .header-facebook {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2800;
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);

    .mobile-header {
      display: none;
      width: 100%;
    }

    @media screen and (max-width: 570px) {
      position: relative;
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
      border-bottom: 0;
      padding: 0;
      margin-bottom: 10px;
      .mobile-header {
        display: block;
      }
    }

    .left-head {
      display: flex;
      svg {
        width: 40px;
        margin-right: 10px;
      }
      form {
        input[type='text'] {
          height: 40px;
          width: 240px;
          border: 0;
          background-color: rgba(240, 242, 245, 1);
          border-radius: 40px;
          padding-left: 40px;
          background-image: url('../assets/img/search-icon.svg');
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: 15px center;
          appearance: none;
        }
      }
      @media screen and (max-width: 1260px) {
        form {
          input[type='text'] {
            width: 40px;
            background-position: 14px center;
          }
        }
      }
      @media screen and (max-width: 570px) {
        display: none;
      }
    }

    .center-head {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      width: 100%;
      max-width: 590px;

      .icon {
        width: 20%;
        height: 57px;
        text-align: center;
        svg {
          position: relative;
          top: 13px;
          path {
            fill: #65676b;
          }
        }
        &:first-child {
          border-bottom: 3px solid #1877f2;
          svg {
            path {
              fill: #1877f2;
            }
          }
        }
      }
      @media screen and (max-width: 1100px) {
        max-width: 50vw;
      }
      @media screen and (max-width: 900px) {
        max-width: 40vw;
      }
      @media screen and (max-width: 800px) {
        display: none;
      }
    }

    .right-head {
      display: flex;
      align-items: center;

      .account {
        display: flex;
        align-items: center;
        margin-right: 20px;

        img {
          width: 30px;
          margin-right: 5px;
        }
        p {
          font-weight: 500;
          font-size: 15px;
          margin: 0;
          padding: 0;
        }
      }

      .right-options {
        width: 184px;
        height: 40px;
      }

      @media screen and (max-width: 1260px) {
        .account {
          display: none;
        }
      }
      @media screen and (max-width: 570px) {
        display: none;
      }
    }
  }

  .feed-facebook {
    display: flex;
    position: static;
    z-index: 2500;
  }

  .left-side-facebook {
    position: fixed;
    top: 57px;
    left: 0;
    padding-left: 8px;
    padding-top: 16px;
    width: 24vw;
    height: 100%;
    overflow-y: scroll;
    .list-item {
      display: flex;
      align-items: center;
      padding: 8px;
      border-radius: 10px;
      cursor: pointer;
      img {
        width: 36px;
        margin-right: 8px;
      }
      p {
        color: #050505;
        font-size: 15px;
        font-weight: 400;
      }
      &.page {
        img {
          border-radius: 36px;
        }
      }
      &:hover {
        background-color: #e4e6e9;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #ced0d4;
      margin: 10px 0;
    }
    .sub-title {
      font-size: 17px;
      color: #65676b;
      font-weight: 500;
      padding-left: 8px;
      margin-top: 16px;
      margin-bottom: 10px;
    }
    @media screen and (max-width: 1100px) {
      display: none;
    }
  }

  .left-side-facebook::-webkit-scrollbar {
    display: none;
  }

  .right-side-facebook {
    position: fixed;
    top: 57px;
    right: 0;
    padding-right: 8px;
    padding-top: 16px;
    width: 24vw;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 80px;
    .list-item {
      display: flex;
      align-items: center;
      padding: 8px;
      border-radius: 10px;
      cursor: pointer;
      img {
        width: 36px;
        margin-right: 8px;
      }
      p {
        color: #050505;
        font-size: 15px;
      }
      &.page {
        img {
          border-radius: 36px;
        }
      }
      &.pub {
        img {
          width: 125px;
          border-radius: 10px;
        }
        .data {
          padding-left: 5px;
        }
        p {
          font-weight: 500;
          &.link {
            opacity: 0.5;
            font-weight: 400;
          }
        }
      }
      &:hover {
        background-color: #e4e6e9;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #ced0d4;
      margin: 10px 0;
    }
    .sub-title {
      font-size: 17px;
      color: #65676b;
      font-weight: 500;
      padding-left: 8px;
      margin-top: 16px;
      margin-bottom: 10px;
      &:first-child {
        margin-top: 5px;
      }
    }
    @media screen and (max-width: 1100px) {
      width: 32vw;
    }
    @media screen and (max-width: 900px) {
      display: none;
    }
  }

  .right-side-facebook::-webkit-scrollbar {
    display: none;
  }

  .center-facebook {
    position: static;
    width: 100%;
    max-width: 590px;
    margin: 0 auto;
    padding-bottom: 300px;
    padding-top: 75px;

    .stories-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 10px 0 20px 0;

      overflow-x: auto;
      overflow-y: hidden;

      .story {
        min-width: 113px;
        height: 201px;
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        margin-right: 5px;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: 0;
          transition: all 0.2s ease;
          z-index: 10;
        }

        img,
        video {
          width: 100%;
          transition: all 0.2s ease;
          position: relative;
          z-index: 1;
        }

        &.is-ph {
          cursor: default;
        }

        &:hover,
        &.is-ph {
          &:before {
            opacity: 0.2;
          }
          img {
            transform: scale(1.05, 1.05);
          }
        }
      }
    }

    .center-wrap-style {
      background-color: #fff;
      border-radius: 10px;
      padding: 12px 16px;
      width: 590px;
      margin-bottom: 10px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);

      .write-post {
        width: 100%;
      }
    }
    @media screen and (max-width: 1240px) {
      max-width: 550px;
      .center-wrap-style {
        width: 550px;
      }
    }
    @media screen and (max-width: 1100px) {
      margin: 0;
      padding-left: 5%;
    }
    @media screen and (max-width: 970px) {
      padding-left: 2%;
    }
    @media screen and (max-width: 900px) {
      padding: 0;
      margin: 0 auto;
    }
    @media screen and (max-width: 570px) {
      max-width: none;
      .center-wrap-style {
        display: none;
      }
    }
  }
}

.instagram-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);

  .phone-frame {
    position: relative;
    top: 0;
    left: 0;
    width: 350px;
    height: 623px;
    min-height: 550px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.1);
  }

  .main-header {
    position: absolute;
    top: 0;
    left: 0;
    padding: 17px 20px 13px 20px;
    background-color: #fff;
    z-index: 1000;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .main-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 13px 20px 17px 20px;
    background-color: #fff;
    z-index: 1000;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .stories-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    overflow-y: scroll;
    padding: 10px;
    padding-bottom: 20px;

    .story {
      background: linear-gradient(90deg, rgba(255, 213, 33, 1) 0%, rgba(245, 0, 0, 1) 35%, rgba(185, 0, 180, 1) 100%);
      padding: 3px;
      border-radius: 100%;
      margin-right: 10px;
      .wrap {
        width: 65px;
        height: 65px;
        overflow: hidden;
        border-radius: 100%;
      }
      img, video {
        width: 100%;
        height: auto;
      }

      &.is-ph {
        opacity: 0.2;
        cursor: default;
        .wrap {
          background-color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .comment-thread {
    width: calc(100% - 30px);
    left: 15px !important;
    bottom: 45px !important;
    top: inherit !important;
  }

  .content {
    width: 100%;
    height: calc(100% - 80px);
    overflow-y: scroll;
    padding-top: 10px;
    position: relative;
    top: 40px;

    .facebook-post-header {
      padding: 10px 12px;
      border-bottom: 1px solid #dbdbdb;

      .post-description {
        display: none;
      }
    }

    .facebook-post {
      width: 100%;
      border-radius: 0;
      box-shadow: none;
      position: relative;
    }

    .post-description {
      margin-top: 0;
      padding: 12px;
    }

    .facebook-client img {
      width: 32px;
      height: 32px;
      flex-basis: 32px;
    }

    .facebook-client-name .name {
      color: #262626;
      font-size: 13px;
      font-weight: 500;
    }

    .facebook-client-name .sponsor img {
      display: none;
    }

    .instagram-ad-footer {
      width: calc(100% - 24px);
      margin: 0 auto;
      margin-top: 12px;
    }

    .fb-ad-footer {
      background-color: #fff;
      padding: 12px;
    }

    .simple-produit .fb-ad-footer .data {
      display: none;
    }

    .fb-ad-footer .cta {
      width: 100%;
      background-color: transparent;
      padding: 0;
      background-image: url('../assets/img/instagram/arrow-cta.svg');
      background-repeat: no-repeat;
      background-position: 100% center;
    }

    .post-footer {
      display: none;
    }

    .carrousel-fb .carousel-cell {
      width: 100%;
      padding-left: 0;
      opacity: 1;
    }

    .carrousel-fb .carousel-cell img {
      width: 100%;
      height: auto;
      border-radius: 0;
      border: 0;
    }

    .carrousel-fb .carousel-cell footer {
      display: none;
    }

    .flickity-prev-next-button {
      display: none !important;
    }

    .flickity-page-dots .dot {
      width: 6px !important;
      height: 6px !important;
      margin: 0 3px !important;
      background: #dbdbdb !important;
      opacity: 1 !important;
    }

    .flickity-page-dots .dot.is-selected {
      background: #0095f6 !important;
    }

    .flickity-page-dots {
      display: block !important;
      bottom: -27px !important;
    }
  }

  @media screen and (max-width: 570px) {
    margin-top: 0;
    position: relative;
    top: 0;
    left: 0;
    transform: translate(0, 0);
    .phone-frame {
      width: 100%;
      height: auto;
      min-height: 0;
      box-shadow: none;
      border-radius: 0;
    }
    .main-header {
      position: relative;
      border-radius: 0;
    }
    .main-footer {
      position: relative;
      border-radius: 0;
    }
    .content {
      height: 100%;
      padding-top: 0;
      padding-bottom: 0;
      top: 0;
    }
  }
}
</style>
